import { MODAL_REMOVE_FROM_EXPERIMENT_IDENTIFIER } from '../../constants';
import { GModalOverlayBackdrop } from '~/presentation/ui';
import { Modal, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

interface IProps {
  open: boolean;
  /** Sentence naming the resource and the experiment it is removed from. */
  description: React.ReactNode;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** Confirmation shown before a pick-resource modal hands a resource back from a draft experiment. */
export const ModalRemoveVariantConfirm: React.FC<IProps> = ({
  open,
  description,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <GModalOverlayBackdrop
        isOpen={open}
        activeModalClass={MODAL_REMOVE_FROM_EXPERIMENT_IDENTIFIER}
      />
      <Modal
        open={open}
        title={t('Remove from experiment')}
        onClose={onClose}
        primaryAction={{
          content: t('Yes, remove'),
          onAction: onConfirm,
          loading: isLoading,
        }}
        secondaryActions={[
          {
            content: t('Cancel'),
            onAction: onClose,
            disabled: isLoading,
          },
        ]}
      >
        <Modal.Section>
          <div className={MODAL_REMOVE_FROM_EXPERIMENT_IDENTIFIER}>
            <Text as="p">{description}</Text>
          </div>
        </Modal.Section>
      </Modal>
    </>
  );
};
